import React from 'react';
import { upperCaseWordSplitAndSpace } from '../../../utils/regex.utils';

const ExperienceEditorComponentPlaceholder = ({ componentName = '', image = '' }) => {
  const formattedName = upperCaseWordSplitAndSpace(componentName);

  if (image) {
    return <img className="experience-editor-component-placeholder__image" src={image} alt={formattedName} loading="lazy" />;
  }
  return <div className="experience-editor-component-placeholder__text">{formattedName} - Component Placeholder</div>;
};

export default ExperienceEditorComponentPlaceholder;
